export default __webpack_public_path__ + "static/media/LogoCarppone.e2f98f5f.svg";